import React from 'react';
import { Section } from '../ui/Section';
import { Skull } from 'lucide-react';
export function ChemicalWarning() {
  return <Section className="bg-brand-danger/5 border-y border-brand-danger/20" data-id="element-44">
      <div className="max-w-4xl mx-auto bg-[#1a0f0f] border border-brand-danger/30 rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-45">
        {/* Background texture/glow */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-brand-danger/10 rounded-full blur-[80px] pointer-events-none" data-id="element-46" />

        <div className="relative z-10 flex flex-col md:flex-row gap-8 items-center" data-id="element-47">
          <div className="flex-shrink-0" data-id="element-48">
            <div className="w-20 h-20 rounded-full bg-brand-danger/20 flex items-center justify-center border border-brand-danger/50" data-id="element-49">
              <Skull className="w-10 h-10 text-brand-danger" data-id="element-50" />
            </div>
          </div>

          <div data-id="element-51">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-52">
              Porque la Pastilla "Azul" o Cualquier Otro Químico{' '}
              <span className="text-brand-danger" data-id="element-53">No Son La Respuesta</span>
            </h2>
            <div className="space-y-4 text-gray-300 text-lg" data-id="element-54">
              <p data-id="element-55">
                Las "pastillas de gasolinera" y los químicos caros de farmacia
                son peligrosos. Solo disfrazan el problema sin solucionar el
                motor.
              </p>
              <p data-id="element-56">
                Te hacen dependiente, vienen con efectos secundarios aterradores
                (dolores de cabeza, visión borrosa, problemas cardíacos) y
                eventualmente,{' '}
                <strong className="text-white" data-id="element-57">dejan de funcionar</strong>.
              </p>
              <p className="text-xl font-serif italic text-brand-lightGold border-l-4 border-brand-danger pl-4 py-2 mt-6" data-id="element-58">
                "Usar químicos en forma de pastillas para la disfunción es como
                ponerle pintura nueva a un carro con el motor fundido. Se ve
                bien por fuera, pero no te llevará a ningún lado."
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}